import React from 'react';
import {Result, Spin} from 'antd';
import logo from "../../assets/btcLogoBlau.png";
import {COLORS} from "../../utils/Colors";

interface MissingAuthorizationPageProps {
    roles: string[];
}

const MissingAuthorizationPage: React.FC<MissingAuthorizationPageProps> = ({ roles }) => {
    const rolesString = roles.join(', ');

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', backgroundColor: COLORS.btcPrimaryGrey }}>
            <img src={logo} alt="Logo" style={{ width: 150, marginBottom: 20, marginLeft: 15 }} />
            <Result
                status="error"
                title="Fehlende Berechtigung"
                subTitle={`Es fehlt eine der folgenden Rollen: ${rolesString}`}
            />
        </div>
    );
};

export default MissingAuthorizationPage;

